import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import axios from "axios";
import env from "config";
import Toast from "components/Toast";
import SsoHandler from "utils/SSOhandler";

const UsersContext = createContext();

const useUsersContext = () => useContext(UsersContext);
const BASE_URL = `${env.API_URL}/v1`;
const FACEBOOK_AUTH = env.FACEBOOK_AUTH;

const UsersProvider = ({ children, match }) => {
  const { SSO, checkSSO, setssodata } = SsoHandler();

  // const socket = useSocketContext();
  const [isActiveSide, setIsActiveSide] = useState(true);
  const [processing, setProcessing] = useState(true);
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [hideloader, sethideloader] = useState(false);
  const [userTyping, setUserTyping] = useState(false);
  const [streamResponse, setStreamResponse] = useState("");
  const [isStreaming, setIsStreaming] = useState(true);
  const [fromPromptMsg, setFromPromptMsg] = useState({});
  const [locationUsers, setLocationusers] = useState();
  const [agencyConfig, setAgencyConfig] = useState({});
  const [agencyInfo, setAgencyInfo] = useState({});
  const [errorType, setErrorType] = useState(false);
  const [newchatloaderhandler, setnewchatloaderhandler] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [loadingStateslide, setLoadingStateslide] = useState({});
  const [chats, setchats] = useState(users);
  const msgRef = useRef("");
  const [fileLoading, setFileLoading] = useState(false);
  const [agentEditMode, setAgentEditMode] = useState(false);
  const [isAuto, setIsAuto] = useState(SSO?.isAuto);
  const [showExploreContent, setShowExploreContent] = useState(true);
  const [selectedAgentText, setSelectedAgentText] = useState(null);
  const [showRetry, setShowRetry] = useState(false);
  const [tempData, setTempData] = useState(null)

  useEffect(() => {
    setIsAuto(SSO?.isAuto);
  }, [SSO?.isAuto]);

  useEffect(() => {
    setchats(users);
  }, [users]);

  const GetChats = async (SSO_data, page = 0, showLoading = true) => {
    // Fetch 10 records for the first request, and 100 records for subsequent requests
    const limit = page === 0 ? 10 : 50;
    const skip = page === 0 ? 0 : (page - 1) * 100 + 10; // Adjust skip logic

    if (showLoading) setProcessing(true); // Show loading spinner only for the first load
    if (newchatloaderhandler === false) {
      sethideloader(true);
    }

    try {
      // Fetch the chats with the calculated limit and skip values
      const response = await axios.get(
        SSO?.conversationId !== ""
          ? `${BASE_URL}/chat/filter?locationId=${SSO?.id}&userId=${SSO?.userUUID}`
          : `${BASE_URL}/chat/filter?locationId=${SSO?.id}&userId=${SSO?.userUUID}&limit=${limit}&skip=${skip}`
      );

      const newChats = response?.data?.data;
      // If page is 0 (first load), set the data; otherwise, append to existing data
      if (page === 0) {
        setData(newChats);
        setUsers(newChats);
        setProcessing(false);
      } else {
        setData((prevData) => [...prevData, ...newChats]);
        setUsers((prevUsers) => [...prevUsers, ...newChats]);
      }

      // Check if there are more chats to load (pagination)
      const totalChats = response.data.totalChats;
      const loadedChats = page === 0 ? 10 : 10 + page * 100;

      if (loadedChats < totalChats) {
        // Load the next chunk only after the current one finishes
        await GetChats(SSO_data, page + 1, false); // Pass `false` to hide loading spinner for subsequent chunks
      }
    } catch (error) {
      console.error("Error loading chats:", error);
    } finally {
      if (showLoading) setProcessing(false); // Hide the loading spinner after the first load completes
      if (SSO?.conversationId !== "") setAgentEditMode(true);
    }
    sethideloader(false);
  };
  const GetchatData = async () => {
    if (newchatloaderhandler === false) {
      sethideloader(true);
    }
    const response = await axios.get(
      `${BASE_URL}/chat/filter?locationId=${SSO?.id}&userId=${SSO?.userUUID}`
    );
    const newChats = response?.data?.data;
    return newChats;
  };
  const getLocationUsers = async (SSO_data) => {
    const response = await axios.get(
      `${BASE_URL}/user/chatusers?locationId=${SSO_data?.id}`
    );
    if (response) {
      setLocationusers(response?.data?.data);
    }
  };

  // const addYourAIinUser = async (SSO_data) => {
  //   const response = await axios.put(
  //     `${BASE_URL}/user/chatuser/yourai?locationId=${SSO_data?.id}&_id=${SSO_data.userUUID}`
  //   );
  //   if (response) {
  //     // setLocationusers(response?.data?.data);
  //   }
  // };

  const getAgencyConfig = async (SSO_data) => {
    const response = await axios.get(
      `${BASE_URL}/agency/agencyconfig?_id=${SSO_data?.agency_id}`
    );

    if (response) {
      setAgencyConfig(response?.data?.data);
      setAgencyInfo(response?.data?.agencyInfo);
    }
  };

  // Function to toggle showExploreContent
  const enableExplore = () => {
    setShowExploreContent(true);
  };

  const enableChat = () => {
    setShowExploreContent(false);
  };

  const [locValid, setlocValid] = useState(data);

  const [toast, setToast] = useState({ message: "", isVisible: false });
  const [toastStyles, setToastStyles] = useState({});

  const showToast = (message, type = "") => {
    // Determine the background color based on the type
    let backgroundColor = "";
    if (type === "err") {
      backgroundColor = "#FF474D";
    } else if (type === "success") {
      backgroundColor = "#9CFF23";
    }

    // Update the toast styles and set the message
    setToastStyles({ background: backgroundColor });
    setToast({ message, isVisible: true });

    // Hide the toast after 10 seconds
    setTimeout(() => setToast({ message: "", isVisible: false }), 10000);
  };

  const hideToast = () => {
    setToast({ message: "", isVisible: false });
  };

  const hideLeftSidebar = () => {
    setIsActiveSide(false);
  };

  const showLeftSidebar = () => {
    setIsActiveSide(true);
  };

  const handleDeleteContact = async (contactId) => {
    const response = await axios.get(`${BASE_URL}/chat/delete?id=${contactId}`);
    return response;
  };

  const _updateUserProp = (userId, prop, value) => {
    setUsers((users) => {
      const usersCopy = [...users];
      let userIndex = users.findIndex((user) => user.id === userId);
      const userObject = usersCopy[userIndex];
      usersCopy[userIndex] = { ...userObject, [prop]: value };
      // setUserTyping(usersCopy);
      return usersCopy;
    });
  };

  const setUserAsTyping = (data) => {
    const { userId } = data;
    setUserTyping(true);
    _updateUserProp(userId, "typing", true);
  };
  const setUserAsNotTyping = (data) => {
    const { userId } = data;
    setUserTyping(false);
    _updateUserProp(userId, "typing", false);
  };

  const setOnFromPrompt = (userId) => {
    setFromPromptMsg(true);
    _updateUserProp(userId, "fromPrompt", true);
  };

  const setOffFromPrompt = (data) => {
    const { userId } = data;
    setFromPromptMsg(false);
    _updateUserProp(userId, "fromPrompt", false);
  };
  function processLinks(response) {
    response = response.replace(/[\[\]\(\)]/g, " ");

    // Regex to find all URLs in the text
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Replace each URL with the corresponding anchor tag
    response = response.replace(urlRegex, (url) => {
      // Remove any trailing parenthesis or unwanted characters from the URL
      url = url.replace(/\)$/, "");

      // Check if the URL is for download (based on the URL or custom logic)
      if (url.includes("Export?id")) {
        // For download links, use normal anchor with download attribute
        return `<a 
          href="${url}" 
          download 
          style="color:#34b0cb !important; cursor:pointer; text-decoration:underline;"
          rel="noopener noreferrer"
        >
          Click to download
        </a>`;
      } else {
        // For regular view links, use plain anchor tag that opens on direct user click only
        // This complies with security headers from external sites like Fireflies
        return `<a 
          href="${url}" 
          target="_blank" 
          rel="noopener noreferrer"
          style="color:#34b0cb !important; cursor:pointer; text-decoration:underline;"
        >
          Click to view
        </a>`;
      }
    });

    return response;
  }

  const extractMessageText = (rawStream) => {
    const lines = rawStream
      .split("\n")
      .filter((line) => line.startsWith("data: "));

    for (const line of lines) {
      try {
        const json = JSON.parse(line.replace("data: ", ""));

        if (json.event === "thread.message.completed") {
          const contentArray = json.data?.content;
          const textObject = contentArray?.find((item) => item.type === "text");
          const value = textObject?.text?.value;

          return value; // ✅ This is your desired message
        }
      } catch (e) {
        console.warn("Invalid JSON line skipped:", line);
      }
    }

    return null;
  };

  const fetchMessageResponse_old = async (data, loadingIndex = "") => {
    const { userId, response, messagetype, fileData, assistant } = data;
    setTimeout(() => {
      setSelectedAgentText('Agent is thinking...')
    }, 4000)
    let pendingRequests = 0; // Local variable to track pending requests

    if (!loadingIndex) {
      setUserAsTyping(data);
    }

    var msg = "";
    let msg_data = JSON.stringify({
      conversation_id: userId,
      profile_id: SSO?.id,
      user_name: SSO?.chat_username,
      prompt: response.content,
      file_ids: fileData?.map((item) =>
        item.id !== null && item.id !== undefined ? item.id : item.name
      ),
      assistant_model_name: assistant?.modal_name,
      assistant_id: assistant?.assistant_id,
      user_id: SSO?.UserInfo?.userId,
      assistant_name: assistant?.assistant_name
    });

    let responses; // Declare outside try-catch for later access
    try {
      pendingRequests++; // Increment before request

      responses = await axios.post(`${BASE_URL}/chat/message`, {
        data: msg_data,
        defualtModel: assistant?.modal_name,
        messagetype: messagetype,
        prompt: response?.content,
        agency_id: SSO?.agency_id,
        isAuto: isAuto,
      });

      if (responses) {
        // Handle isAuto response structure
        if (responses?.data?.data?.data?.reply || responses?.data?.data?.reply) {
          msg = processLinks(responses?.data?.data?.data?.reply || responses?.data?.data?.reply);
          setUserAsNotTyping(data);
          if (loadingIndex) {
            setLoadingStateslide((prev) => ({
              ...prev,
              [loadingIndex]: false,
            }));
          }
        } else if (
          !responses?.data?.data?.data &&
          responses?.data?.data?.includes("thread.run.created")
        ) {
          const rawData = responses?.data?.data;
          msg = extractMessageText(rawData);
          setUserAsNotTyping(data);
          if (loadingIndex) {
            setLoadingStateslide((prev) => ({
              ...prev,
              [loadingIndex]: false,
            }));
          }
        } else {
          msg = processLinks(responses?.data?.data?.data);
          setUserAsNotTyping(data);
          if (loadingIndex) {
            setLoadingStateslide((prev) => ({
              ...prev,
              [loadingIndex]: false,
            }));
          }
        }
      }
    } catch (error) {
      console.log(error, 'messageError');
      // await axios.get(BASE_URL + "/chat/delete?id=" + userId).catch(function (error) { });
      setUserAsNotTyping(data);
      setShowRetry(true)
      setTempData(data)
      return;
    } finally {
      pendingRequests--; // Decrement after completion
    }

    let userIndex = users.findIndex((user) => user.id === userId);
    const usersCopy = JSON.parse(JSON.stringify(users));
    const newMsgObject = {
      content: msg,
      sender: userId,
      time: new Date().toLocaleTimeString(),
      status: null,
      assistant_name:
        responses?.data?.data?.data?.assistant_name ||
        assistant?.assistant_name,
      plugins_used: responses?.data?.data?.data?.plugins_used || [],
    };
    const payload = {
      message: newMsgObject,
      conversation_id: userId,
    };

    try {
      pendingRequests++;
      await axios.post(BASE_URL + "/message/response", { ...payload });
      setTimeout(async () => {
        await GetChats()
      }, 12);
    } catch (error) {
      console.log(error);
    } finally {
      pendingRequests--; // Decrement after second request
      setSelectedAgentText(null)
    }

    // Hide loader only when all requests complete
    // if (pendingRequests === 0) {
    sethideloader(false);
    setFileLoading(false);
    // }
  };

  const fetchMessageResponse = async (data, loadingIndex = "") => {
    const { userId, response, messagetype, fileData, assistant } = data;

    if (!loadingIndex) {
      setUserAsTyping(data);
    }

    // if (SSO?.is_streaming_Api) {
    //   let msg = "";
    //   setIsStreaming(true);
    //   let lastReplyJson = null; // To store the last JSON response with "reply"
    //   try {
    //     const res = await fetch(`${BASE_URL}/chat/stream`, {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "Bearer " + process.env.REACT_APP_PANDORA_API_KEY,
    //       },
    //       body: JSON.stringify({
    //         data: JSON.stringify({
    //           conversation_id: userId,
    //           profile_id: SSO?.id,
    //           user_name: SSO?.chat_username,
    //           prompt: response.content,
    //           file_ids: fileData?.map((item) => item.id ?? item.name),
    //           assistant_model_name: assistant.modal_name,
    //           assistant_id: assistant.assistant_id,
    //         }),
    //         defualtModel: assistant.modal_name,
    //         messagetype: messagetype,
    //         prompt: response.content,
    //         agency_id: SSO?.agency_id,
    //         isStreaming: true,
    //       }),
    //     });

    //     const reader = res.body.getReader();
    //     const decoder = new TextDecoder("utf-8");
    //     let done = false;
    //     let buffer = "";

    //     while (!done) {
    //       const { value, done: readerDone } = await reader.read();
    //       done = readerDone;
    //       if (value) {
    //         buffer += decoder.decode(value, { stream: true });

    //         // Process each SSE event (split by double newlines)
    //         let events = buffer.split("\n\n");
    //         buffer = events.pop(); // Keep the last incomplete event in buffer

    //         for (let event of events) {
    //           if (event.startsWith("data: ")) {
    //             let jsonStr = event.replace(/^data: /, "").trim();
    //             if (jsonStr === "[DONE]") continue; // End of stream

    //             try {
    //               const chunkJSON = JSON.parse(jsonStr);
    //               // Save the last reply event if it contains "reply"
    //               if (chunkJSON.reply) {
    //                 lastReplyJson = chunkJSON;
    //               }
    //               // Handle your event type here
    //               if (
    //                 chunkJSON.event === "thread.message.delta" &&
    //                 chunkJSON.data?.delta?.content
    //               ) {
    //                 let content = chunkJSON.data.delta.content[0]?.text?.value;
    //                 if (content) {
    //                   setTimeout(() => {
    //                     setStreamResponse((prev) => prev + content);
    //                     msg += content;
    //                   }, 250);
    //                   msgRef.current += content;
    //                 }
    //               }
    //             } catch (err) {}
    //           }
    //         }
    //       }
    //     }

    //     // Handle any remaining data in the buffer
    //     if (buffer.trim().startsWith("data: ")) {
    //       let jsonStr = buffer.replace(/^data: /, "").trim();
    //       try {
    //         const chunkJSON = JSON.parse(jsonStr);
    //         if (chunkJSON.reply) {
    //           lastReplyJson = chunkJSON;
    //         }
    //         if (
    //           chunkJSON.event === "thread.message.delta" &&
    //           chunkJSON.data?.delta?.content
    //         ) {
    //           let content = chunkJSON.data.delta.content[0]?.text?.value;
    //           if (content) {
    //             setStreamResponse((prev) => prev + content);
    //             msgRef.current += content;
    //           }
    //         }
    //       } catch (err) {}
    //     }
    //   } catch (error) {
    //     console.error("Error fetching assistant response:", error);
    //   } finally {
    //     const interval = setInterval(async () => {
    //       if (msg.length === msgRef.current.length) {
    //         clearInterval(interval);
    //         setStreamResponse("");
    //         setIsStreaming(false);
    //         if (loadingIndex) {
    //           setLoadingStateslide((prev) => ({
    //             ...prev,
    //             [loadingIndex]: false,
    //           }));
    //         }

    //         // Persist the final message to backend
    //         try {
    //           let userIndex = users.findIndex((user) => user.id === userId);
    //           const usersCopy = JSON.parse(JSON.stringify(users));
    //           const newMsgObject = {
    //             content: msgRef.current.replace("undefined", ""),
    //             sender: userId,
    //             time: new Date().toLocaleTimeString(),
    //             status: null,
    //             assistant_name: lastReplyJson?.assistant_name,
    //             plugins_used: lastReplyJson?.plugins_used,
    //           };
    //           const payload = {
    //             message: newMsgObject,
    //             conversation_id: userId,
    //           };

    //           await axios.post(BASE_URL + "/message/response", { ...payload });
    //           var key = Object.keys(usersCopy[userIndex].messages)[0];
    //           usersCopy[userIndex].messages[key].push(newMsgObject);
    //           setUsers(usersCopy);
    //           setUserAsNotTyping(data);
    //           sethideloader(false);
    //           setFileLoading(false);
    //           msgRef.current = "";

    //           // Handle and console.log the last reply JSON if present
    //           if (lastReplyJson) {
    //             console.log("Last reply JSON:", lastReplyJson);
    //           }
    //         } catch (error) {
    //           console.error("Error saving message:", error);
    //         }
    //       }
    //     }, 250);
    //   }
    // } else {
    await fetchMessageResponse_old(data, loadingIndex);
    // }
  };

  const justToSaveMsg = async (msg, userId) => {
    let userIndex = users.findIndex((user) => user.id === userId);
    const usersCopy = JSON.parse(JSON.stringify(users));
    const newMsgObject = {
      content: msg,
      sender: userId,
      time: new Date().toLocaleTimeString(),
      status: null,
    };
    const payload = {
      message: newMsgObject,
      conversation_id: userId,
    };
    await axios
      .post(BASE_URL + "/message/response", { ...payload })
      .then(async function (response) { })
      .catch(function (error) { });
    if (usersCopy[userIndex]?.messages) {
      var key = Object.keys(usersCopy[userIndex]?.messages);
      key = key[0];
      usersCopy[userIndex].messages[key].push(newMsgObject);
      setUsers(usersCopy);
    }
    sethideloader(false);
    setFileLoading(false);
  };
  const Chatoption = async (userId, message) => {
    await axios
      .get(BASE_URL + "/super_admin_settings")
      .then(async function (response) {
        fetchMessageResponse({
          userId: userId,
          response: { content: message },
          defualtModel: response.data.data.default_modal,
        });
      });
  };
  const refresh = (newdata) => {
    users.unshift(newdata);
    setUsers(users);
  };

  const onLoad = (SSO) => {
    if (SSO !== "" && SSO !== undefined) {
      getLocationUsers(SSO);
      getAgencyConfig(SSO);
      GetChats(SSO, 0, true);
      // addYourAIinUser(SSO);
    }
  };
  useEffect(() => {
    onLoad(SSO);
  }, [SSO]);

  // useEffect(() => {
  //   if (data.length && !processing) {
  //     GetChats(SSO, 1, false);
  //   }
  // }, [data]);

  useEffect(() => {
    checkSSO();
  }, []);

  const setUserAsUnread = (userId) => {
    _updateUserProp(userId, "unread", 0);
  };

  const ChatSubmit = async (payload, fromPrompt = false, loader = true) => {
    setUserTyping(loader)
    return await axios
      .post(BASE_URL + "/chat", {
        userId: {
          id: SSO?.userUUID,
          type: "author",
          username: SSO?.chat_username,
        },
        ...payload,
        isAuto: isAuto,
      })
      .then(async function (response) {
        var chat_data = {};
        chat_data["Welcome " + response.data.data.username] = [];
        const chat = {
          id: response.data.data.conversation_id,
          locationId: response.data.data.locationId,
          userId: response.data.data.userId,
          name: "",
          whatsapp_name: response.data.data.username,
          messages: chat_data,
          welcome_array: "Welcome " + response.data.data.username,
          fromPrompt: fromPrompt,
        };
        setnewchatloaderhandler(false);
        setTempData(null)
        setShowRetry(false)
        return chat;
      })
      .catch(function (error) {
        console.log("triggered");
        if (error.response.data.message === "limit reached")
          window.parent.postMessage(
            {
              type: "limitReached",
              message: "Upgrade to Build a Custom Agent",
            },
            "*"
          );
        return error;
      });
  };

  const addNewMessage = async (
    userId,
    message,
    prompt,
    type,
    selectedFiles = [],
    assistant,
    messagetype,
    fileType = ""
  ) => {
    setUserTyping(true)
    setSelectedAgentText('Selecting an Agent...')
    const agentTimeout = setTimeout(() => {
      setSelectedAgentText('Agent Selected')
    }, 2000);
    if (selectedFiles && selectedFiles.length > 0) {
      setFileLoading(true);
    }

    const fileData = selectedFiles?.map((file) => ({
      id: file.id,
      name: file.name,
    }));
    let userIndex = users.findIndex((user) => user.id === userId);
    var usersCopy = JSON.parse(JSON.stringify(users));

    const newMsgObject = {
      content: message,
      sender: null,
      time: new Date().toLocaleTimeString(),
      status: "delivered",
      // Store the file data in the new message object
      file_ids: fileData,
      file_type: fileType, // KB | PNG
      assistant_name: assistant?.assistant_name || "",
    };

    var key = Object.keys(usersCopy[userIndex].messages);
    key = key[0];

    if (type === "savetodb") {
      usersCopy[userIndex].messages[key].push(newMsgObject);
    }

    const payload = {
      message: newMsgObject,
      conversation_id: userId,
      type: type,
    };

    setUsers(usersCopy);

    try {
      const response = await axios.post(BASE_URL + "/message", { ...payload })
      if (response.data.chatupdated) {
        await GetChats()
      }

      await fetchMessageResponse({
        userId: userId,
        ...(prompt !== undefined ? { response: { content: prompt } } : { response: { content: message } }),
        messagetype: messagetype,
        fileData: fileData,
        assistant: assistant,
      });

    } catch (error) {
      clearTimeout(agentTimeout);
      if (SSO?.type !== "free" && error.response.data.errorType !== 'balance') {
        setUserTyping(false);
        setSelectedAgentText(null);
        window.parent.postMessage(
          {
            type: "limitReached",
            message: "Upgrade to add more AI Agent tasks",
          },
          "*"
        );
        // showToast(error?.response?.data?.message);
      }

      if (
        SSO?.type === "free" &&
        error.response.data.message === "Reached to limit"
      ) {
        setUserTyping(false);
        setSelectedAgentText(null);
        window.parent.postMessage(
          {
            type: "limitReached",
            message: "Upgrade to add more AI Agent tasks",
          },
          "*"
        );
      }
      if (error.response.data.errorType === "balance") {
        setUserTyping(false);
        setSelectedAgentText(null);
        // showToast(error.response.data.message, "err");
        setErrorType(true);
        setErrorMsg(error.response.data.message);
      }
    }
  };

  const contextuploadFilefrominput = async (
    files,
    chatId = "",
    setSpinnerLoading
  ) => {
    // return 0
    const audioformData = new FormData();
    const formData = new FormData();
    const audiofilestype = [
      "audio/mpeg", // mp3
      "video/mp4", // mp4
      "video/mpeg", // mpeg
      "audio/mp4", // m4a
      "audio/wav", // wav
    ];
    const audiofiles = [];
    const otherFiles = [];
    let audioTranscript = "";
    let fileError = false;
    let errorMessage = "";

    for (let index = 0; index < files.length; index++) {
      const fileType = files[index].file?.type;

      if (audiofilestype.includes(fileType)) {
        audiofiles.push(files[index]);
      } else {
        otherFiles.push(files[index]);
      }
    }

    // Append allowed files to formData

    for (let file of audiofiles) {
      audioformData.append("file", file.file ? file.file : file);
      audioformData.append("translate", file.isChecked);
    }
    for (let file of otherFiles) {
      formData.append("file", file.file ? file.file : file);
    }
    audioformData.append("profile_id", SSO?.id);
    audioformData.append("username", SSO?.chat_username);
    audioformData.append("model_name", "openai/gpt-4o");
    formData.append("profile_id", SSO?.id);
    formData.append("username", SSO?.chat_username);
    formData.append("model_name", "openai/gpt-4o");

    if (audiofiles.length > 0) {
      try {
        const response = await axios.post(
          `${BASE_URL}/chat/multimedia`,
          audioformData,
          {
            "Content-Type": "multipart/form-data", // Optional: axios sets this automatically
          }
        );
        if (response) {
          return response;
        }
        audioTranscript = response;
      } catch (error) {
        console.log(error);
        fileError = true;
      }
    }

    if (otherFiles.length > 0) {
      try {
        const response = await axios.post(
          `${BASE_URL}/chat/multimedia`,
          formData,
          {
            "Content-Type": "multipart/form-data", // Optional: axios sets this automatically
          }
        );
        if (response) {
          setSpinnerLoading(false);
          return response;
        }
      } catch (error) {
        setSpinnerLoading(false);
        fileError = true;
        errorMessage = error?.response?.data?.message;
      }
    }
    if (fileError) {
      setSpinnerLoading(false);
      return {
        status: fileError,
        transcript: audioTranscript,
        message: errorMessage,
      };
    } else {
      setSpinnerLoading(false);
      return {
        status: "uploaded",
        transcript: audioTranscript,
      };
    }
  };

  const createMemory = async (profileId, content) => {
    let data = JSON.stringify({
      content: content,
    });
    try {
      const response = await axios.post(`${BASE_URL}/chat/assistants/memory`, {
        profile_id: profileId,
        data: data,
      });
      if (response) {
        return response.data.data;
      }
    } catch (error) {
      return error;
    }
  };

  const updateMemory = async (profileId, content) => {
    let data = JSON.stringify({
      content: content,
    });
    try {
      const response = await axios.put(`${BASE_URL}/chat/assistants/memory`, {
        profile_id: profileId,
        data: data,
      });
      if (response) {
        return response.data.data;
      }
    } catch (err) {
      return "error";
    }
  };

  const deleteMemory = async (profileId) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/chat/assistants/memory/delete`,
        {
          profile_id: profileId,
        }
      );
      if (response) {
        return response.data.data;
      }
    } catch (error) {
      return error;
    }
  };

  const getMemory = async (profileId) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/assistants/memory?profile_id=${profileId}`
      );
      if (response) {
        return response.data.data;
      }
    } catch (error) {
      return error;
    }
  };

  const values = useMemo(
    () => ({
      setFileLoading,
      fileLoading,
      chats,
      setchats,
      users,
      SSO,
      data,
      setUsers,
      hideloader,
      sethideloader,
      setnewchatloaderhandler,
      locValid,
      setlocValid,
      setUserAsUnread,
      addNewMessage,
      contextuploadFilefrominput,
      processing,
      refresh,
      userTyping,
      hideLeftSidebar,
      showLeftSidebar,
      isActiveSide,
      handleDeleteContact,
      toast,
      showToast,
      hideToast,
      showExploreContent,
      enableExplore,
      enableChat,
      setOnFromPrompt,
      setOffFromPrompt,
      fromPromptMsg,
      Chatoption,
      getLocationUsers,
      locationUsers,
      handleRefreshData: GetChats,
      GetchatData,
      agencyConfig,
      agencyInfo,
      errorType,
      setErrorType,
      errorMsg,
      justToSaveMsg,
      ChatSubmit,
      getMemory,
      createMemory,
      updateMemory,
      deleteMemory,
      checkSSO,
      fetchMessageResponse,
      setLoadingStateslide,
      loadingStateslide,
      streamResponse,
      isStreaming,
      setssodata,
      setAgentEditMode,
      agentEditMode,
      setIsAuto,
      isAuto,
      selectedAgentText,
      tempData,
      setTempData,
      showRetry,
      setShowRetry,
      fetchMessageResponse_old
    }),
    [
      SSO,
      setFileLoading,
      fileLoading,
      chats,
      setchats,
      users,
      SSO,
      data,
      setUsers,
      hideloader,
      sethideloader,
      setnewchatloaderhandler,
      locValid,
      setlocValid,
      setUserAsUnread,
      addNewMessage,
      contextuploadFilefrominput,
      processing,
      refresh,
      userTyping,
      hideLeftSidebar,
      showLeftSidebar,
      isActiveSide,
      handleDeleteContact,
      toast,
      showToast,
      hideToast,
      showExploreContent,
      enableExplore,
      enableChat,
      setOnFromPrompt,
      setOffFromPrompt,
      fromPromptMsg,
      Chatoption,
      getLocationUsers,
      locationUsers,
      GetChats,
      GetchatData,
      agencyConfig,
      agencyInfo,
      errorType,
      setErrorType,
      errorMsg,
      justToSaveMsg,
      ChatSubmit,
      getMemory,
      createMemory,
      updateMemory,
      deleteMemory,
      checkSSO,
      fetchMessageResponse,
      setLoadingStateslide,
      loadingStateslide,
      streamResponse,
      isStreaming,
      setssodata,
      setAgentEditMode,
      agentEditMode,
      setIsAuto,
      isAuto,
      selectedAgentText,
      tempData,
      setTempData,
      showRetry,
      setShowRetry,
      fetchMessageResponse_old
    ]
  );

  return (
    <UsersContext.Provider value={values}>
      {children}
      {toast.isVisible && (
        <Toast
          message={toast.message}
          styles={toastStyles}
          onClose={hideToast}
        />
      )}
    </UsersContext.Provider>
  );
};

export { useUsersContext, UsersProvider };
